module.exports = __webpack_public_path__ + "img/edit.08285c94.png";